import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { media } from "style-utils";
import { merge, isEmpty } from 'lodash';

import numeral from 'numeral';
import { NitroContentNotAvailable } from "nitro-components";


import Highcharts from 'highcharts';
import RHC from 'react-highcharts';
import theme from '../highcharts-themes/summary';
import { getColour } from '../highcharts-themes/helper';
import exporting from "highcharts/modules/exporting";



exporting(Highcharts);
const ReactHighcharts = RHC.withHighcharts(Highcharts);

import {
  NitroText,
  NitroFormatter,
} from "nitro-components";

const ChartContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const SummaryPanel = styled.div`
  & > span {
    display: block;
    text-align: center;
  };
  padding: 20px 0;
  border-bottom: solid 1px #ddd;
  flex: 1 0 50%;
`

const SummaryBlock = styled.div`
  display: flex;
`;

const SummaryItem = styled.div`
  padding: 0 10px 10px;

  & .chartSummary .highcharts-container {
    & > svg {
      overflow: visible;
    };

    overflow: visible !important;
    height: inherit !important;
    ${media.mobile`
      height: inherit !important;
    `};
  };

  &.chartHolder {
    width: 150px;
    padding: 10px 0 10px 10px;

    & > span {
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &.valign-middle {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &.talign-center {
    text-align: center;
  }

  &.display-info {
    text-align: right;
    flex: 1;
    & > span {
      font-weight: bolder;
      white-space: nowrap;
    }
  }

  &.trend-holder {
    margin-left: auto;
    padding-right: 15px;
    padding-left: 0;
    width: 30px;
  }
`;

const IconBox = styled.div`
  display: block;
  font-size: 28px;
  text-shadow: 2px 2px 10px #999;
`;

const IconTrend = styled.div`
  display: block;
  font-size: 16px;
`


const TrendDisplay = ({prevNumber, currNumber}) =>{
  let perc = 0;
  let isUp = false;

  if(prevNumber && prevNumber > 0 && currNumber && currNumber > 0) {
    const delta = currNumber - prevNumber;
    isUp = (delta > 0)? true: false;
    perc = (delta === 0 )? 0 : Math.ceil( Math.abs(delta) / prevNumber * 100);
  } else {
    perc = NaN;
  }

  let color = '#707070';
  let iconClass = 'fas fa-ellipsis-h';
  let percDisplay = 'No data';

  if (isNaN(perc) || perc === 0) {
    return null;
  }

  percDisplay = perc + '%';
  if(perc === 0) {

  } else if ( isUp ) {
    color = 'red';
    iconClass = 'fas fa-angle-up';
  } else {
    color = 'green';
    iconClass = 'fas fa-angle-down';
  }


  return (
    <div style={{ color }}>
      <IconTrend className={iconClass} />
      <NitroText size={11} >{percDisplay}</NitroText>
    </div>
  )
}

const SummaryBox = ({data, config, metadata}) => {
  // Apply the theme
  // Highcharts.theme = theme;

  const metaDefault = {
    icon: 'fas fa-car',
    chartDescription: '',
    valueType: 'shortinteger'
  }

  const metainfo = merge({}, metaDefault, metadata)

  const chartCfg = {
    chart:{
      height: 40,
      width: 150,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    tooltip: {
      outside: true,
      useHTML: true,
      positioner: function(lw, lh, point) {
        const ypos = point.plotY - 10 - lh;
        return {x: point.plotX, y:ypos};
      },
      formatter: function() {
        let disp = this.y;
        switch(metainfo.valueType) {
          case 'shortcurrency':
            disp = numeral(disp).format('$ 0.00 a');
            break;
          default:
          case 'shortinteger':
            disp = numeral(disp).format('0a');
            break
        }

        return `
        <div>
          <div style="padding-bottom: 5px; border-bottom: solid 1px #ddd;">
            <b style="white-space:nowrap; ">${this.series.name}</b>
          </div>
          <div style="padding-top: 5px; white-space:nowrap;">
            ${this.x} <br/> ${disp}
          </div>
        </div>`;
      }
    },
    xAxis: {
      categories: config.categoryGroups,
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    series: [
      {
        type: 'spline',
        name: config.category,
        data: data,
        marker: {
          enabled: false,
        },
        showInLegend: false,
      }
    ],
    title: {
      text: ''
    }
  }

  const dataCount = data.filter(ea => typeof(ea) === 'number').length;

  return (
    <SummaryPanel>
    { metainfo.chartDescription.length > 0 &&
      <NitroText variant="base2" size={11}>{metainfo.chartDescription || ''}</NitroText>
    }
      <SummaryBlock>
        <SummaryItem className="valign-middle">
          <IconBox className={ metainfo.icon } />
        </SummaryItem>

        <SummaryItem className="talign-center chartHolder">
          <ReactHighcharts config={chartCfg} domProps = {{className:'chartSummary'}}/>
        </SummaryItem>

        <SummaryItem className="valign-middle display-info">
          <NitroFormatter type={metainfo.valueType} variant="secondary" size={17} data={config.displayNumber} />
        </SummaryItem>

          <SummaryItem className="valign-middle talign-center trend-holder">
            { dataCount > 2 &&
              <TrendDisplay
                currNumber={data[dataCount-1]}
                prevNumber={data[dataCount-2]}
              />
            }
          </SummaryItem>

      </SummaryBlock>
  </SummaryPanel>
  )
}

class ChartSummarySpline extends Component {

  render() {
    const {data, metadata} = this.props;
    const parsedmeta = JSON.parse(metadata.metadata);

    if(isEmpty(data.summaryData)) {
      return <NitroContentNotAvailable />
    }

    return (
      <ChartContainer>
        {
          parsedmeta.config.map((ea) => {
            if(ea && data.summaryData[ea.category]) {
              return <SummaryBox
                {...data.summaryData[ea.category]}
                metadata={ea}
                key={ea.category}/>
            }
          })
        }
      </ChartContainer>
    )
  }
}

ChartSummarySpline.propTypes = {
  data: PropTypes.object.isRequired,
  metadata: PropTypes.object.isRequired
}

export default ChartSummarySpline;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartSummarySpline.js